const ToolboxInfo = {
  maxInstances: {
    image_setter_block: 2,
    label_text_setter_block: 2,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "image_setter_block",
          },
          {
            kind: "block",
            type: "label_text_setter_block",
            inputs: {
              value: {
                shadow: {
                  type: "text",
                },
              },
            },
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
